export enum PROMOBAR_SKINS {
  HOLIDAY = "holiday",
  HOLIDAY_GREEN = "holiday-green",
  DISCOUNT = "discount",
  HOLIDAY_BEIGE = "holiday-beige",
  INVERSE = "inverse",
  STANDARD = "standard",
}

export type A11yText = {
  previousMessage: string
  nextMessage: string
}

export type Message = {
  skin: PROMOBAR_SKINS
  content: string
  preceedingWord?: string
  copyIcon?: string
  abTestServerData?: {
    experimentKey: string
    variationKey: string
  }
  couponCode?: string
}

export type PromoBarConfiguration = {
  type: string
  tracking: string
}

export type Config = {
  staleTTL: number
  expiredTTL: number
}

export type CommsBarApiResponse = {
  config: Config
  a11yText: A11yText
  promobarConfiguration: PromoBarConfiguration
  messages: Message[]
  excludedPageTypes: string[]
  contentfulLinkWithoutCoupon: string | undefined
  contentfulLinkWithCoupon: string | undefined
}

export type MainProps = {
  tenant?: string
  locale?: string
  pageType?: string
  pageId?: string
  data?: CommsBarApiResponse
}

export type TrackingConfig = {
  eventName: string
  properties: {
    [k: string]: string
  }
  linkAttributes?: {
    [k: string]: string | number
  }
}

